import React from 'react';
import t from '~t';
import { target } from '~target';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Label, Select } from '~ui';

export default function SettingsAppRaindropsClick() {
  const raindrops_click = useSelector((state) => state.config.raindrops_click);
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('bookmarkClick')}</Label>
      <div>
        <Select
          value={raindrops_click}
          onChange={(e) => dispatch(set('raindrops_click', e.target.value))}
        >
          {[
            ['current_tab', t.s('open')],
            ['new_tab', t.s('openInNewTab')],
            ...(target != 'extension'
              ? [
                  ['preview', t.s('preview')],
                  ['web', 'Web'],
                ]
              : []),
            ['edit', t.s('edit')],
          ].map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Select>
      </div>
    </>
  );
}
